module.exports = __webpack_public_path__ + "files/ef6c6016b0280d60c78e63292f17c44c.png";